import { getStatusModulos } from '../api/statusModulos'
import { ModulosDeshabilitados } from '../interfaces/modulosDeshabilitados.interface'
import { ModulosDeshabilitadosYsocial } from '../interfaces/ysocial/modulosDeshabilitadosYsocial.interface'

const getDefaultStatusModulos = (aplicacion: string): ModulosDeshabilitadosYsocial | ModulosDeshabilitados => {
    if (aplicacion === 'ysocial') {
        return {
            deshabilitarControlVerdes: false,
            deshabilitarGeolocalizacion: false,
            deshabilitarGeolocalizacionExacta: false,
            deshabilitarValidacionPlan: false,
        }
    }
    return {
        deshabilitarControlVerdes: false,
        deshabilitarGeolocalizacion: false,
        deshabilitarGeolocalizacionExacta: false,
        deshabilitarServiciosMultiples: false,
        deshabilitarValidacionPlan: false,
        deshabilitarWhatsappEmergencia: false,
        deshabilitarWhatsappMenorMeses: false,
        deshabilitarWhatsappNoEncuentroSintoma: false,
        deshabilitarWhatsappZona: false
    }
}

export const loadStatusModulos = (version, aplicacion, apiRequest) => {
    return new Promise<ModulosDeshabilitadosYsocial | ModulosDeshabilitados>((resolve, reject) => {
        getStatusModulos(version, aplicacion, apiRequest)
            .then(data => {
                const statusModulos = { ...getDefaultStatusModulos(aplicacion), ...data }
                resolve(statusModulos)
            })
            .catch(err => reject(err))
    })
}